export default "__VITE_ASSET__128bd3dc__"